export var OVERLAY_CLASS_PREFIX = 'Overlay';